/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMerchantMarketLaunchCohortEnrollments} from '../api'

 export const useQueryGetMerchantMarketLaunchCohortEnrollments = createReactQueryHook('getMerchantMarketLaunchCohortEnrollments', getMerchantMarketLaunchCohortEnrollments)
